import builder from '../builder';
import QuestionCircle from '../../streamline-icons/bold/question-circle.svg';

export default builder('IconQuestionCircleBold', QuestionCircle);
